import { atom, selector } from "recoil";
import { DataType } from "@types";

export const originalDataState = atom<DataType[]>({
  key: "originalData",
  default: [],
});

export const lastUpdateDateState = selector<string>({
  key: "lastUpdateDate",
  get: ({ get }) => {
    return get(originalDataState).reduce((prev, current) => {
      const prevDate = new Date(prev.latest_at).getTime();
      const currentDate = new Date(current.latest_at).getTime();
      return prevDate > currentDate ? prev : current;
    }).latest_at;
  },
});
